import React, { useState } from 'react'
import { AreaChart } from "@carbon/charts-react";
import { InlineLoading } from 'carbon-components-react';
import TableToolbarDownload from '../../common/TableToolbarDownload';
import * as DashboardConstants from './DashboardConstants'

require("./_dashboard-donut-chart.scss");

const DashboardAreaChart = (props) => {
    const defaultAreaChartOptions = {
        "title": props.modalTitle,
        "axes": {
            "bottom": {
                "title": props.graphXAxisTitle || DashboardConstants.Time,
                "mapsTo": "date",
                "scaleType": props.bottomScaleType || "labels" //"time"
            },
            "left": {
                "title": props.graphTitle,
                "mapsTo": "value",
                "scaleType": "linear"
            }
        },
        "legend": {
            "position": "top",
            "orientation": "horizontal",
            "alignment": "right"
        },
        "curve": "curveMonotoneX",
        "data": {
            "loading": props.loading
        },
        "height": props.height ? props.height : "400px",
    };

    const areaGraphHeaders = [
        {
            key: 'group',
            header: DashboardConstants.Group
        },
        {
            key: 'value',
            header: DashboardConstants.Value
        }
    ];

    const graphOptions = defaultAreaChartOptions;

    return (
        <div className="dashboard-area-chart-container">
            <div className="graph-title carbon-display-Regular-20">
                <div>{props.title}</div>
                <div className="download-button">
                    {props.hideDownloadButton !== true && <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={props.areaGraphData} headers={areaGraphHeaders} title={props.title} filename={DashboardConstants.Export} label={DashboardConstants.Download} />}
                </div>
            </div>
            {!props.loading ?
                props.areaGraphData.length ?
                    <AreaChart
                        data={props.areaGraphData}
                        options={graphOptions}>
                    </AreaChart>
                    :
                    <div>{DashboardConstants.NoDataAvailable}</div>
                :
                <div className="tile loading-container">
                    <InlineLoading
                        description={DashboardConstants.Loading}
                    />
                </div>
            }
        </div>
    );
};

export default DashboardAreaChart;
